// extracted by mini-css-extract-plugin
export default {"tasks":"Oinkedit_tasks__XBUBW","right":"Oinkedit_right__6R6y2","taskbar":"Oinkedit_taskbar__KeBBu"};